import {action, observable} from 'mobx';
import {databaseRef} from '../../helperFunctions/firebaseStore';
import {IPickup, IPickupAddData, IPickupEditData, IPickupsStore} from "../storeInterfaces/pickupsStoreInterface";
import {convertObjToArray} from "./ordersStore";


export class PickupsStore implements IPickupsStore {

    @observable
    pickups: IPickup[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    editPickup = (pickupId: string, dataToEdit: IPickupEditData) => {
        dataToEdit.fee = +dataToEdit.fee;
        return databaseRef.ref('/pickups/' + pickupId).update(dataToEdit);
    };

    @action
    addPickup = (pickupToAdd: IPickupAddData) => {
        const pickupId = databaseRef.ref('/pickups/').push(pickupToAdd).key;
        pickupToAdd.fee = +pickupToAdd.fee;
        return databaseRef.ref('/pickups/' + pickupId).set({...pickupToAdd, pickupId});
    };

    @action
    deletePickup = (pickupId: string) => {
        return databaseRef.ref('/pickups/' + pickupId).remove();
    };

    @action
    getPickupById = (pickupId: string) => {
        return databaseRef.ref('/pickups/' + pickupId).once('value');
    };

    @action
    async getPickups() {
        try {
            await databaseRef.ref('/pickups/').on('value', snapshot => {
                this.pickups = snapshot ? convertObjToArray(snapshot.val()) : [];
                this.pickups = this.pickups.map(b => ({...b, edit: 'Edit', delete: 'Delete', id: b.pickupId}))
                this.loaded = true;
            });
        } catch (e) {
            this.failed = true;
        }

    }
}